import Checkbox from 'atoms/Checkbox';
import { useState } from 'react';
import Button from '../atoms/Button';
import DialogBox from '../molecules/DialogBox';

const TermsAndCondition = ({
    show, onConfirm, buttonLoading, onClose
}) => {
    const [isTermsAgreed, setIsTermsAgreed] = useState(false);
    const [isBgcAgreed, setIsBgcAgreed] = useState(false);
    if (!show) return null;
    return (
        <DialogBox
            title="Terms and Conditions"
            subTitle=''
            width='w-full max-w-[912px]'
            isClose={false}
            close={onClose}
            bodySpacing="mb-6"
            titleStyle='text-center mb-1'>
            <Checkbox
                isSelected={isTermsAgreed}
                className='mb-3 mt-[72px]'
                handleChange={() => setIsTermsAgreed(!isTermsAgreed)}
                checkBoxLabel={
                    <>
                        I have read and agree to the{' '}
                        <a
                            href="/files/deon_t&c.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="border-b border-primary-300 text-primary-300"
                        >
                            DEON Terms and Conditions.
                        </a>
                    </>
                }
                labelClassName="!text-gray-200"
            />
            <Checkbox
                isSelected={isBgcAgreed}
                handleChange={() => setIsBgcAgreed(!isBgcAgreed)}
                checkBoxLabel={
                    <>
                        I acknowledge and agree to abide by the{' '}
                        <a
                            href="/files/bgc_singapore_rulebook.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="border-b border-primary-300 text-primary-300"
                        >
                            BGC PARTNERS (Singapore) Operating Rulebook.
                        </a>
                    </>
                }
                labelClassName="!text-gray-200"
            />
            <div className='flex justify-center mt-[72px]'>
                <Button label="Accept the terms" type='primary' onClick={onConfirm} loading={buttonLoading}
                    disabled={!isTermsAgreed || !isBgcAgreed} />
            </div>
        </DialogBox >
    );
};

export default TermsAndCondition;
